import { SOURCE_ICON } from "@/mappings/source_icon";
import { cx } from "@/utils";

import styles from "../Cover.module.css";

const Fallback = ({ source, className, ...props }) => {
  const Icon = SOURCE_ICON[source];

  return (
    <div className={cx(styles.fallback, className)} {...props}>
      {Icon && <Icon width="33%" />}
    </div>
  );
};

export default Fallback;
